import React, { Component } from 'react'
import CaseService from '../serviceComponents/CaseService/index'
import './index.css'
import Translate from "translate-components";
import  Arrow  from '../../../Basic/Footer/arrow.svg';
import LogoRed from '../../../DynamicContent/About/dsideLogo.svg';
import Advantages from "../../../Basic/TrustBlocks/Advantages";
import withDsideApi from "../../../../HOC/Fetch";
import Footer from '../../../Basic/Footer'
import { NavLink } from "react-router-dom";
import Helmet from 'react-helmet-async'
import  PricingFeatures  from '../../../Basic/TrustBlocks/PricingFeatures';

class Website extends Component {
componentWillMount() {
  this.setState({lang: localStorage.getItem('lang')})
  };
  render(){

    return (

        <div>
        <Helmet>
  <title>Strony internetowe - DSIDE</title>
</Helmet>

            <div className="s-intro-txts-websites"><div className="lines-intro-websites">
                 <div className="heading-s-intro"> <h2 className="s-intro-txt"><Translate>World-class websites</Translate></h2></div>
                 <h4 className="s-intro-txt "><Translate>Are created by</Translate><img className="logo-s-intro" src={LogoRed} width={60}/></h4>
</div>
            </div>
          <div className="websites-content">

             <div className="row">
               <div className="d-c-main">
                   <div className="d-c-head">
                  <div className="heading-design"><h2><Translate>Websites</Translate></h2> <Translate>from 1999 PLN</Translate></div>
                  <div className="calclink"><NavLink
                      to={`/${this.state.lang}/pricing`}
                      className="link adv-btn a1">
                      <Translate>Prices</Translate><img src={Arrow} width={16} alt=""/>  </NavLink></div></div>
                  <p><Translate>We create awesome, super fast and scalable web apps for all purposes! Also we combine them with our bright and spectacular design. This will leave no chance to competitors, because your company will look more professional than analogues with a mediocre design.</Translate></p>
               </div>
             </div>
            </div>
        <CaseService {...this.props} name='websites' />
        <Advantages />
               <div className="row"><PricingFeatures/></div>
        <Footer/> </div>
    )
  }
}
export default withDsideApi(Website, '/portfolio/getPortfolioItems/Websites/')


// WEBPACK FOOTER //
// ./src/components/CompanyPages/Services/websites/index.js